var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProperty1IconoirVoice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 1.25C10.4142 1.25 10.75 1.58579 10.75 2V18C10.75 18.4142 10.4142 18.75 10 18.75C9.58579 18.75 9.25 18.4142 9.25 18V2C9.25 1.58579 9.58579 1.25 10 1.25ZM14 4.25C14.4142 4.25 14.75 4.58579 14.75 5V15C14.75 15.4142 14.4142 15.75 14 15.75C13.5858 15.75 13.25 15.4142 13.25 15V5C13.25 4.58579 13.5858 4.25 14 4.25ZM2 5.0498C2.41421 5.0498 2.75 5.38559 2.75 5.7998V14.7998C2.75 15.214 2.41421 15.5498 2 15.5498C1.58579 15.5498 1.25 15.214 1.25 14.7998V5.7998C1.25 5.38559 1.58579 5.0498 2 5.0498ZM6 6.25C6.41421 6.25 6.75 6.58579 6.75 7V13C6.75 13.4142 6.41421 13.75 6 13.75C5.58579 13.75 5.25 13.4142 5.25 13V7C5.25 6.58579 5.58579 6.25 6 6.25ZM18 7.25C18.4142 7.25 18.75 7.58579 18.75 8V12C18.75 12.4142 18.4142 12.75 18 12.75C17.5858 12.75 17.25 12.4142 17.25 12V8C17.25 7.58579 17.5858 7.25 18 7.25Z",
    fill: "#444444"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProperty1IconoirVoice);
export default __webpack_public_path__ + "static/media/Property 1=iconoir_voice.fb66dc4700667ec9729e428c7df4db82.svg";
export { ForwardRef as ReactComponent };